import { gql } from '@apollo/client';

export const CREATE_TEAM_MEMBERS = gql`
  mutation createTeamMembers($inputs: [UpsertTeamMembersInput!]!) {
    teamMembers: createTeamMembers(inputs: $inputs) {
      id
    }
  }
`;
